const KEY = "wok_admin_token";

export const adminAuth = {
  get: () => {
    try {
      return localStorage.getItem(KEY) || "";
    } catch {
      return "";
    }
  },
  set: (token) => {
    try {
      localStorage.setItem(KEY, token);
    } catch {
      /* ignore */
    }
  },
  clear: () => {
    try {
      localStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  },
  authHeader: () => {
    const t = adminAuth.get();
    return t ? { Authorization: `Bearer ${t}` } : {};
  },
};
